import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, Card, Col, Row, Button, Spinner } from 'react-bootstrap';
import snakeCaseKeys from 'snakecase-keys';
import { useHistory } from 'react-router-dom';
import DigitalSignImageEdit from '../../../screens/Employee/EmployeeForm/DigitalSignImageEdit';
import { updateEmployeeRequest } from '../../../requests/employees';
import Icon from '../../Icons';
import { sendAlert } from '../../../actions/utils';
import { useAuthorization } from '../../../services/hooks';
import CustomWebcam from '../../CustomWebCam';
import { UploadImage } from '../../Utils/Upload';
import { SimpleCenteredModal } from '../../Utils/Modal';

const PersonalData = ({ employee, setMoreData, moreData, onRequest, employeeProfile, activeAccordion, activeKey }) => {
  const {
    birthdate,
    country,
    firstLastName,
    name,
    nationalIdentification,
    nationalIdExpirationDate,
    profiles,
    secondLastName,
    translatedCivilState,
    gender,
    digitalSignImage,
    substituteName,
    username,
    translatedIdentificationType
  } = employee;

  const profileNames = profiles.map(profile => profile.label);
  const collaborator = employee.collaborator ? 'Sí' : 'No';

  const history = useHistory();

  const canRecordCard = useAuthorization('update_as_employee', 'Employee');

  const canUpdateData = canRecordCard;

  const onlyIconButton = {
    padding: '0.2rem',
    marginRigth: 10
  };

  const [modalShow, setModalShow] = useState(false);
  const [fieldType, setFieldType] = useState('');
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const dispatch = useDispatch();

  const handleShowModal = field => {
    setFieldType(field);
    setModalShow(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleSuccessUpdate = () => {
    setLoadingUpdate(false);
    dispatch(sendAlert({ kind: 'success', message: 'Trabajador actualizado con éxito' }));
    setModalShow(false);
    history.go(0);
  };

  const pickVariables = (_employee = {}, ...params) => ({
    ...params.reduce((prev, current) => ({ ...prev, [current]: _employee[current] }), {})
  });

  const handleFailureRequest = error => {
    dispatch(sendAlert({ kind: 'error', message: error?.response?.data?.message }));
  };

  const { currentEmployee } = useSelector(state => state.auth);

  const handleUpdateRequest = (employeeValues, setSubmitting) => {
    setLoadingUpdate(true);
    const { employee: copyEmployee } = employeeValues;

    let myParams = {
      employee: { ...copyEmployee }
    };
    const keepVariables = {
      digitalSign: ['digitalSign']
    };

    myParams.employee = {
      ...pickVariables(myParams.employee, ...keepVariables.digitalSign),
      send_email_udpated_employee_signature: true,
      digital_sign: employeeValues.digitalSign
    };

    let testParams = { employee: { send_email_udpated_employee_signature: true } };

    testParams = snakeCaseKeys(testParams, {
      exclude: ['_destroy']
    });

    testParams.employee.digital_sign = employeeValues.employee.digitalSign;

    myParams = snakeCaseKeys(myParams, {
      exclude: ['_destroy']
    });

    const employeeId = employee.id || currentEmployee;

    updateEmployeeRequest(employeeId, {
      dispatch,
      params: testParams,
      formData: true,
      failureCallback: handleFailureRequest,
      successCallback: handleSuccessUpdate,
      callback: () => {
        setSubmitting(false);
        setLoadingUpdate(false);
      }
    });
  };

  return (
    <Card className="mr-2">
      <Col className={`${activeKey === 'personal-data' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
        <Accordion.Toggle as={Col} eventKey="0" onClick={activeAccordion} className="card-header-title">
          Información Personal
        </Accordion.Toggle>
      </Col>
      <Accordion.Collapse eventKey="0">
        <Card.Body className="div-content px-4 personal-data">
          <Row className="mt-3">
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Nombre:</span>
                <span className={`answer ${!name ? 'text-grey' : ''}`}>{name || 'No Aplica'}</span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Primer Apellido:</span>
                <span className={`answer ${!firstLastName ? 'text-grey' : ''}`}>{firstLastName || 'No Aplica'}</span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Segundo Apellido:</span>
                <span className={`answer ${!secondLastName ? 'text-grey' : ''}`}>{secondLastName || 'No Aplica'}</span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Identificación ({translatedIdentificationType || '—'}):</span>
                <span className={`answer ${!nationalIdentification ? 'text-grey' : ''}`}>
                  {nationalIdentification || 'No Aplica'}
                </span>
              </div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Fecha vencimiento Identificación:</span>
                <span className={`answer ${!nationalIdExpirationDate ? 'text-grey' : ''}`}>
                  {nationalIdExpirationDate || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Fecha de Nacimiento:</span>
                <span className={`answer ${!birthdate ? 'text-grey' : ''}`}>{birthdate || 'No Aplica'}</span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Nacionalidad:</span>
                <span className={`answer ${!country?.label ? 'text-grey' : ''}`}>{country?.label || 'No Aplica'}</span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Género:</span>
                <span className={`answer ${!gender?.label ? 'text-grey' : ''}`}>{gender?.label || 'No Aplica'}</span>
              </div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Estado Civil:</span>
                <span className={`answer ${!translatedCivilState ? 'text-grey' : ''}`}>
                  {translatedCivilState || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Sustituto:</span>
                <span className={`answer ${!substituteName ? 'text-grey' : ''}`}>{substituteName || 'No Aplica'}</span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Perfil:</span>
                <span className={`answer ${!profileNames?.length ? 'text-grey' : ''}`}>
                  {profileNames.length ? profileNames.join(', ') : 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Es Colaborador:</span>
                <span className={`answer ${collaborator == null ? 'text-grey' : ''}`}>
                  {collaborator != null ? collaborator : 'No Aplica'}
                </span>
              </div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Firma:</span>
                <div className={`answer d-flex align-items-center ${!digitalSignImage?.fileUrl ? 'text-grey' : ''}`}>
                  {digitalSignImage?.fileUrl ? (
                    <img
                      src={digitalSignImage.fileUrl}
                      alt="Firma digital"
                      style={{ width: '150px', height: '50px', objectFit: 'contain' }}
                    />
                  ) : (
                    'No Aplica'
                  )}
                  {canUpdateData && employeeProfile && (
                    <Button
                      disabled={onRequest}
                      size="sm"
                      className="ml-2"
                      style={onlyIconButton}
                      onClick={() => {
                        setMoreData(!moreData);
                        handleShowModal(true);
                      }}
                    >
                      <Icon icon="pencil" className="icon-15" />
                    </Button>
                  )}
                </div>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Usuario del Sistema:</span>
                <span className={`answer ${!username ? 'text-grey' : ''}`}>{username || 'No Aplica'}</span>
              </div>
            </Col>
          </Row>
          {onRequest && (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <Spinner animation="border" variant="primary" />
            </div>
          )}
        </Card.Body>
      </Accordion.Collapse>

      <SimpleCenteredModal
        title="Editar firma digital"
        body={
          <DigitalSignImageEdit
            fieldType={fieldType}
            employee={employee}
            CustomWebcam={CustomWebcam}
            UploadImage={UploadImage}
            formRequest={handleUpdateRequest}
            handleModalClose={handleModalClose}
            dispatch={dispatch}
            loadingUpdate={loadingUpdate}
          />
        }
        show={modalShow && !onRequest}
        centered
        size="lg"
        onHide={() => setModalShow(false)}
      />
    </Card>
  );
};

export default PersonalData;
